import { createContext } from "react";

export const BackDropContext = createContext(null);